var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardBooking({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,6.9c0.7,0.3,1.3,0.6,1.9,0.9C6.8,8,7.2,8.2,7.6,8.4c0.1,0.1,0.2,0.2,0.2,0.3c0,2.4,0,4.9,0,7.3c0,0,0,0.1,0,0.2 c-0.1-0.1-0.3-0.1-0.4-0.2C5.2,15,3,13.8,0.7,12.7c-0.4-0.2-0.5-0.4-0.5-0.8c0-2.2,0-4.3,0-6.5c0-0.1,0-0.3,0-0.4 C0.4,4.9,0.5,5,0.6,5C1.4,5.4,2.2,5.8,3,6.2c0.2,0.1,0.3,0.3,0.3,0.5c0,0.7,0,1.4,0,2.1c0,0.5,0.2,0.7,0.6,0.7 c0.4,0,0.6-0.2,0.6-0.7C4.5,8.2,4.5,7.6,4.5,6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,16.3c0-0.2,0-0.3,0-0.5c0-2.3,0-4.6,0-6.9C9,8.6,9,8.5,9.3,8.4c2.3-1.1,4.6-2.2,6.9-3.3c0.1,0,0.2-0.1,0.3-0.1 c0,0.2,0,0.3,0,0.4c0,0.9,0,1.7,0,2.6c0,0.3,0,0.4-0.4,0.5c-1.3,0.1-2.2,1.4-1.8,2.7c0.1,0.3,0,0.5-0.3,0.6c-1.2,0.7-2.1,1.7-2.6,3 c-0.1,0.2-0.3,0.4-0.5,0.5C10.3,15.6,9.7,15.9,9,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9,3.8C15.7,3.9,15.6,4,15.5,4C13.2,5.2,11,6.3,8.7,7.4C8.5,7.5,8.3,7.5,8,7.4C7.2,6.9,6.4,6.6,5.6,6.1 C5.4,6.1,5.3,6,5.2,5.9c0.2-0.1,0.3-0.2,0.4-0.2c2.2-1.1,4.5-2.2,6.7-3.4c0.3-0.1,0.5-0.1,0.7,0c0.8,0.4,1.7,0.8,2.6,1.2 C15.6,3.7,15.7,3.7,15.9,3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4,13.6c-1.6,0-3.2,1.3-3.5,2.9c-0.2,0.8-0.1,1.6-0.2,2.4c0,0.1,0,0.3,0,0.4c-0.1,0.3-0.3,0.4-0.7,0.4 c-0.3,0-0.5-0.2-0.5-0.5c-0.1-1.8-0.1-3.5,1.2-5c0.9-1.1,2.1-1.8,3.5-1.9c0.1,0,0.1,0,0.2,0c0,0,0.1-0.1,0.1-0.1 c-0.1-0.1-0.2-0.1-0.3-0.2c-0.3-0.2-0.6-0.5-0.8-0.7c-0.4-0.4-0.5-0.7-0.3-1.1c0.3-0.3,0.6-0.3,1.1,0.1c0.8,0.7,1.6,1.4,2.3,2.1 c0.5,0.4,0.5,0.7,0,1.2c-0.8,0.7-1.6,1.4-2.5,2.2c-0.3,0.3-0.7,0.3-0.9,0c-0.3-0.3-0.2-0.7,0.1-1C16.5,14.4,16.9,14,17.4,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2,1.5c-0.2,0.1-0.3,0.2-0.4,0.2C8.6,2.9,6.4,4,4.1,5.1c-0.2,0.1-0.4,0.1-0.7,0C2.7,4.8,2,4.4,1.3,4.1 C1.1,4,1,3.9,0.8,3.8C1,3.7,1.1,3.7,1.3,3.6c2.2-1.1,4.4-2.1,6.6-3.2c0.4-0.2,0.7-0.2,1,0C9.6,0.8,10.4,1.1,11.2,1.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardBooking);
export default __webpack_public_path__ + "static/media/forwardBooking.8bac2155.svg";
export { ForwardRef as ReactComponent };